import { useTranslation } from 'react-i18next'

import { useUk } from '../../../hooks'
import { ProfileActionsWidget } from '../../Widget'
import { useRequestProfileContext } from '../RequestProfile.hooks'

import { useRequestProfileActionsWidgetHandlers } from './RequestProfileActionsWidget.hooks'
import { getRequestProfileActionsWidgetItems } from './RequestProfileActionsWidget.utils'

import * as styles from './RequestProfileActionsWidget.module.css'

function RequestProfileActionsWidget({
  className = styles.RequestProfileActionsWidget,
  isSkeleton,
  onClickBack,
}) {
  const { t } = useTranslation()

  const { config: ukConfig } = useUk()

  const { requestData } = useRequestProfileContext()

  const {
    addNewOptions,
    attachedRequestsOptions,
    getUploadFileInputProps,
    handleClickAction,
    handleSelectAddNewOption,
    handleSelectAttachedRequestsOption,
  } = useRequestProfileActionsWidgetHandlers({ onClickBack })

  const actions = getRequestProfileActionsWidgetItems({
    addNewOptions,
    attachedRequestsOptions,
    requestData,
    t,
    ukConfig,
    onClickBack,
    onSelectAddNewOption: handleSelectAddNewOption,
    onSelectAttachedRequestsOption: handleSelectAttachedRequestsOption,
  })

  return (
    <>
      <ProfileActionsWidget
        actions={actions}
        className={className}
        contentContainerProps={{
          className: styles.actionsContent,
        }}
        isSkeleton={isSkeleton}
        onClickAction={handleClickAction}
      />
      <input {...getUploadFileInputProps()} />
    </>
  )
}

export default RequestProfileActionsWidget
